import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewportService } from '@shared/common/services/viewport/viewport.service';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  standalone: false
})
export class TooltipComponent {
  @Input() content = '';
  @Input() icon = 'fa-circle-info';
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
  @Input() isVisibleOnMobile = true;
  @Input() hasDrawer = true;
  @Input() tooltipModalId = '';
  @Output() tooltipClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  readonly positionPrefix = 'tooltip__text--';

  get tooltipPosition(): string {
    return this.positionPrefix + this.position;
  }

  get isMobile(): boolean {
    return this.viewportService.isMobileDevice();
  }

  constructor(private readonly viewportService: ViewportService) {}

  openTooltipModal(): void {
    if (!this.hasDrawer) {
      return;
    }
    this.tooltipClicked.emit();
  }
}
